import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import DocumentationList from './DocumentationList';
import DocumentationEditor from './DocumentationEditor';
import DocumentationViewer from './DocumentationViewer';

function Documentation() {
  return (
    <Routes>
      <Route path="/" element={<DocumentationList />} />
      <Route path="/new" element={<DocumentationEditor />} />
      <Route path="/edit/:id" element={<DocumentationEditor />} />
      <Route path="/view/:id" element={<DocumentationViewer />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default Documentation;
